// extracted by mini-css-extract-plugin
export var bold = "_s3-0";